import login from '@/pages/login'
import adminLayout from '@/pages/layout/admin-layout'
import devManage from '@/pages/admin/dev-manage'
import learnManage from '@/pages/layout/learn-manage'
import classManage from '@/pages/layout/class-manage'
import versionManage from '@/pages/layout/version-manage'
import specialVersionManage from '@/pages/layout/special-version-manage'
import volumeManage from '@/pages/layout/volume-manage'
import specialVolumeManage from '@/pages/layout/special-volume-manage'
import sectionManageBk from '@/pages/layout/section-manage/index'
import sectionManageZk from '@/pages/layout/section-manage/exam'
import sectionManageShijuan from '@/pages/layout/section-manage/shijuan'
import knowledgeManage from '@/pages/layout/knowledge-manage'
import examtypeManage from '@/pages/layout/examtype-manage'
import examhardManage from '@/pages/layout/examhard-manage'
// 通用管理
import commonLevelOne from '@/pages/layout/common-manage/levelone'
import commonLevelTwo from '@/pages/layout/common-manage/leveltwo'
import commonLevelThree from '@/pages/layout/common-manage/levelthree'
// 试卷
import shijuanTypeLink from '@/pages/layout/shijuan-manage/type-link'
import shijuanTypeMap from '@/pages/layout/shijuan-manage/type-map'

import devInfo from '@/pages/admin/dev-info'
import istatistics from '@/pages/admin/istatistics'
import interfaceManage from '@/pages/admin/interface-manage'
import istatisticsCustomer from '@/pages/admin/istatistics/customer'
import istatisticsInterface from '@/pages/admin/istatistics/interface'
import sysmanage from '@/pages/admin/sys-manage'
import applyuser from '@/pages/admin/applyuser-manage'
import rolemanage from '@/pages/admin/role-manage'
import addDeveloper from '@/pages/admin/add-developer/index'
import modifyDeveloper from '@/pages/admin/add-developer/modify'
import openAndRenew from '@/pages/admin/add-developer/openAndRenew'
import e403 from '@/pages/error/e403'
import e404 from '@/pages/error/e404'

export default [
  {
    path: '/admin/layout',
    name: 'adminlayout',
    component: adminLayout,
 //   redirect: '/admin/devmanage',
    children: [
      { path: '/admin/devmanage',
        name: 'devmanage',
        component: devManage,
        meta: {
          menu: '开发者管理'
        }
      },
      { path: '/admin/devmanage/addDeveloper',
        name: 'addDeveloper',
        component: addDeveloper,
        meta: {
          menu: '开发者管理'
        }
      },
      { path: '/admin/devmanage/modifyDeveloper',
        name: 'modifyDeveloper',
        component: modifyDeveloper,
        meta: {
          menu: '开发者管理'
        }
      },
      { path: '/admin/devmanage/openAndRenew',
        name: 'openAndRenew',
        component: openAndRenew,
        meta: {
          menu: '开发者管理'
        }
      },
      { path: '/admin/applyuser',
        name: 'applyuser',
        component: applyuser,
        meta: {
          menu: '在线申请'
        }
      },
      { path: '/admin/interfacemanage',
        name: 'interfacemanage',
        component: interfaceManage,
        meta: {
          menu: '开发者管理'
        }
      },
      { path: '/admin/devinfo',
        name: 'devinfo',
        component: devInfo,
        meta: {
          menu: '开发者管理'
        }
      },
      // 调用接口统计
      { path: '/admin/istatistics',
        name: 'istatistics',
        component: istatistics,
        meta: {
          menu: '整体趋势'
        }
      },
      // 调用接口统计
      { path: '/admin/istatistics/istatisticsInterface',
        name: 'istatisticsInterface',
        component: istatisticsInterface,
        meta: {
          menu: '按接口统计'
        }
      },
      // 调用接口统计
      {
        path: '/admin/istatistics/customer',
        name: 'istatisticsCustomer',
        component: istatisticsCustomer,
        meta: {
          menu: '开发者管理'
        }
      },
      { path: '/admin/sysmanage',
        name: 'sysmanage',
        component: sysmanage,
        meta: {
          menu: '用户管理'
        }
      },
      { path: '/admin/rolemanage',
        name: 'rolemanage',
        component: rolemanage
      },
      {
        path: '/admin/learnManage',
        name: 'learnManage',
        component: learnManage,
        meta: {
          menu: '学段管理'
        }
      },
      {
        path: '/admin/classManage',
        name: 'classManage',
        component: classManage,
        meta: {
          menu: '科目管理'
        }
      },
      {
        path: '/admin/versionManage',
        name: 'versionManage',
        component: versionManage,
        meta: {
          menu: '版本管理'
        }
      },
      {
        path: '/admin/specialVersionManage',
        name: 'specialVersionManage',
        component: specialVersionManage,
        meta: {
          menu: '版本管理'
        }
      },
      {
        path: '/admin/volumeManage',
        name: 'volumeManage',
        component: volumeManage,
        meta: {
          menu: '册别管理'
        }
      },
      {
        path: '/admin/specialVolumeManage',
        name: 'specialVolumeManage',
        component: specialVolumeManage,
        meta: {
          menu: '册别管理'
        }
      },
      // {
      //   path: '/admin/sectionManage',
      //   name: 'sectionManage',
      //   component: sectionManage,
      //   meta: {
      //     menu: '章节管理'
      //   },
      //   children: [

      //   ]
      // },
      {
        path: '/admin/sectionManage/tbbk',
        name: 'sectionManageTbbk',
        component: sectionManageBk,
        meta: {
          menu: '同步备课'
        }
      },
      {
        path: '/admin/sectionManage/zkgk',
        name: 'sectionManageZkgk',
        component: sectionManageZk,
        meta: {
          menu: '中考高考'
        }
      },
      {
        path: '/admin/sectionManage/shijuan',
        name: 'sectionManageShijuan',
        component: sectionManageShijuan,
        meta: {
          menu: '试卷大全'
        }
      },
      {
        path: '/admin/knowledgeManage',
        name: 'knowledgeManage',
        component: knowledgeManage,
        meta: {
          menu: '知识点管理'
        }
      }, {
        path: '/admin/examtypeManage',
        name: 'examtypeManage',
        component: examtypeManage,
        meta: {
          menu: '试题类型管理'
        }
      }, {
        path: '/admin/examhardManage',
        name: 'examhardManage',
        component: examhardManage,
        meta: {
          menu: '试题难度管理'
        }
      },
      // 通用
      {
        path: '/admin/commonLevelOne',
        name: 'commonLevelOne',
        component: commonLevelOne,
        meta: {
          menu: '一级标签'
        }
      },
      {
        path: '/admin/commonLevelTwo',
        name: 'commonLevelTwo',
        component: commonLevelTwo,
        meta: {
          menu: '二级标签'
        }
      },
      {
        path: '/admin/commonLevelThree',
        name: 'commonLevelThree',
        component: commonLevelThree,
        meta: {
          menu: '三级标签'
        }
      },
      // 试卷
      {
        path: '/admin/shijuanTypeLink',
        name: 'shijuanTypeLink',
        component: shijuanTypeLink,
        meta: {
          menu: '栏目类型关联'
        }
      },
      {
        path: '/admin/shijuanTypeMap',
        name: 'shijuanTypeMap',
        component: shijuanTypeMap,
        meta: {
          menu: '新老类型映射'
        }
      }
    ]
  },
  {
    path: '/admin/login',
    name: 'login',
    component: login
  },
  {
    path: '/error/403',
    name: 'e403',
    component: e403
  },
  {
    path: '/error/404',
    name: 'e404',
    component: e404
  }
]



// WEBPACK FOOTER //
// ./src/router/modules/admin.js